import { useParams } from 'react-router-dom';

import { AppCategoryPage } from '~/components/pages/AppCategoryPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppContentRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCategoryPage appId={appId} />
    </DashboardTemplate>
  );
};
